export class EnumDisplay {
    public static readonly CreditRequestStatus = {
        1: 'Approved',
        2: 'Denied',
        3: 'Pending',
        4: 'Pending'
    };

    public static readonly PurchasesStatus = {
        1: 'Submitted',
        2: 'Processing',
        3: 'Under<br/>Review',
        4: 'Processed',
        5: 'Ineligible'
    };

    public static readonly PurchasesStatusPopover = {
        1: 'Your invoice submission has not been reviewed by LSQ yet.',
        2: 'Your invoice submission is being processed by the Purchasing department.',
        3: 'Your invoice submission is being reviewed by your Account Manager and Account Executive.',
        4: 'Your invoices have been fully processed.',
        5: 'Invoices that LSQ will not fund against. An invoice may become ineligible because it is: missing verification, past due, over credit limit, in dispute, etc.'
    };
}
